import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const BytElavtal = lazy(() => import("@/pages/elavtal/BytElavtal"));

export const Route = createFileRoute("/elavtal/byt")({
  head: () => seoHead("/elavtal/byt"),
  component: () => <BytElavtal />,
});
